import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ElectronicDeviceType } from '@base/backend';

export function createKaufpreisProductForm(): FormGroup<ElektronikProductFormModel> {
  return new FormGroup<ElektronikProductFormModel>({
    productGroup: new FormControl<ElectronicDeviceType | null>(null, [Validators.required]),
    brand: new FormControl<string | null>(null, [Validators.required]),
    model: new FormControl<string | null>(null, [Validators.required]),
    serialNumber: new FormControl<string | null>(null, [Validators.required])
  });
}

export interface ElektronikProductFormModel {
  productGroup: FormControl<ElectronicDeviceType | null>;
  brand: FormControl<string | null>;
  model: FormControl<string | null>;
  serialNumber: FormControl<string | null>;
}